import $ from 'jquery'
import _ from 'lodash'
import { JSONEditor } from '@json-editor/json-editor'
import store from '../../store'
import EventBus from '../../helpers/event-bus'

class AssetEditor extends JSONEditor.AbstractEditor {
  build () {
    this.title = this.header = this.label = this.theme.getFormInputLabel(this.getTitle())
    this.input = this.theme.getFormInputField('hidden')

    const label = _.startCase(this.schema.options.assetButtonLabel || this.schema.options.assetType)
    this.button = this.theme.getButton(`Add ${label}`, null, `Add ${label}`, 'btn-primary')

    // clear button
    this.clear = this.theme.getButton(`Remove ${label}`, null, `Remove ${label}`, 'btn-outline-danger')
    this.clear.style.minWidth = 'auto'

    this.replace = this.theme.getButton(`Select New ${label}`, null, `Select New ${label}`)
    this.replace.style.minWidth = 'auto'

    // set button initial states
    $(this.clear).toggleClass('d-none', !this.value)
    $(this.replace).toggleClass('d-none', !this.value)
    $(this.button).toggleClass('d-none', !!this.value)

    this.button.onclick = this.replace.onclick = async (event) => {
      // console.info('Triggering Asset Manager', this.schema.options.assetType)

      // pass schema options to the asset manager
      store.commit('assets/setOptions', this.schema.options)

      var $manager = $('#asset-manager-modal')
      $manager.one('selected', (event, { file }) => {
        store.commit('assets/setSelectedId', null)
        this.setValue(file.url)
      })

      // when modal is closed stop listening
      $manager.on('hide.bs.modal', () => {
        $manager.off('selected')
      })

      $manager.modal('show')

      if (!store.state.assets.loaded) {
        await store.dispatch('assets/update')
      }

      store.dispatch('assets/selectByFilename', this.value)
    }

    this.clear.onclick = (event) => {
      this.setValue(null)
    }

    this.preview = document.createElement('div')
    this.preview.classList.add('preview')
    this.preview.classList.add('fade')

    this.control = document.createElement('div')
    this.control.classList.add('d-flex')
    this.control.classList.add('flex-column')
    this.control.classList.add('align-items-start')

    this.buttons = document.createElement('div')
    this.buttons.classList.add('d-flex')
    this.buttons.classList.add('asset-buttons')
    this.buttons.appendChild(this.replace)
    this.buttons.appendChild(this.clear)

    // check for description
    if (_.has(this.schema, 'description')) {
      this.description = this.theme.getFormInputDescription(_.get(this.schema, 'description'))
      this.control.appendChild(this.description)
    }

    this.control.appendChild(this.input)
    this.control.appendChild(this.button)
    this.control.appendChild(this.preview)
    this.control.appendChild(this.buttons)

    // check for preview
    this.refreshPreview()

    EventBus.$on('assets:updated', this.refreshPreview)

    this.container.appendChild(this.control)
  }

  async refreshPreview () {
    if (!this)
      return

    if (this.value) {
      var el
      // add preview for authoring tool
      switch (this.schema.options.assetType) {
        case 'image':
          el = document.createElement('img')
          el.classList.add('mt-0')
          el.src = this.value
          break
        case 'audio':
          el = document.createElement('audio')
          el.controls = true
          el.src = this.value
          break
        case 'video':
          el = document.createElement('video')
          el.controls = true
          el.src = this.value
          break
        case 'document':
          el = this.theme.getButton('View Document', 'book', 'View Document', 'btn-dark')
          el.style.minWidth = 'auto'
          el.onclick = (event) => {
            window.open(this.value)
          }
          break
        default:
          break
      }

      if (el) {
        el.title = this.value
        this.preview.innerHTML = ''
        this.preview.appendChild(el)
        _.defer(() => {
          this.preview.classList.add('show')
        })
      }

      const metadata = document.createElement('div')
      metadata.classList.add('mt-2')
      metadata.innerHTML = `<span>Filename:</span> <span class="text-muted">Fetching...</span>`
      this.preview.appendChild(metadata)

      // api call to get media metadata
      const regex = /\/(\d+)\//gm

      let source = null
      const matches = regex.exec(this.value)
      if (matches) {
        source = await store.dispatch('assets/getFile', { id: matches[1], useCache: true })
      }

      if (source) {
        metadata.innerHTML = `<span>Filename:</span> <strong>${source.name}</strong>`
      } else {
        metadata.innerHTML = `<span>Filename:</span> <span class="text-muted">${this.value}</span>`
      }
    } else {
      this.preview.innerHTML = ''
    }
  }
  
  attachAsset () {
    this.jsoneditor.options.assets[this.path] = {
      filename: this.value,
      options: this.schema.options
    }
  }
  
  removeAsset () {
    delete this.jsoneditor.options.assets[this.path]
  }
  
  onChange (bubble) {
    this.notify()
    this.watch_listener && this.watch_listener()
    bubble && this.change()

    if (this.value === null) {
      this.removeAsset()
    } else {
      this.attachAsset()
    }

    this.refreshPreview()
    $(this.clear).toggleClass('d-none', !this.value)
    $(this.replace).toggleClass('d-none', !this.value)
    $(this.button).toggleClass('d-none', !!this.value)
  }
  
  enable () {
    if (!this.always_disabled) {
      if (this.input) {
        this.input.disabled = false
      }
      super.enable()
    }
  }
  
  disable (always_disabled) {
    if (always_disabled) {
      this.always_disabled = true
    }
    if (this.input) {
      this.input.disabled = true
    }
    super.disable()
  }
  
  setValue (val) {
    if (this.value !== val) {
      this.input.value = this.value = val
      this.onChange()

      if (this.parent) {
        this.parent.onChildEditorChange(this)
      } else {
        this.jsoneditor.onChange()
      }
    }
  }
  
  destroy () {
    if (this.preview && this.preview.parentNode) {
      this.preview.parentNode.removeChild(this.preview)
    }
    if (this.title && this.title.parentNode) {
      this.title.parentNode.removeChild(this.title)
    }
    if (this.input && this.input.parentNode) {
      this.input.parentNode.removeChild(this.input)
    }

    EventBus.$off('assets:updated', this.refreshPreview)

    super.destroy()
  }
  
  addLinks () {
    // do nothing
  }
}

export default AssetEditor
